<script>
import { deliveryInfoProps, useDeliveryInfo } from "./mixin";

import LazyImage from "@/components/atoms/lazy-image";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Divider from "@/components/atoms/divider";
import withdrawalOver from "@/assets/icons/withdrawal-over.svg";
import box from "@/assets/icons/box.svg";
import scanQrcode from "@/assets/icons/scan-qrcode.svg";

export default {
  name: "OrderConfirmationDeliveryInfoPrcDelipop",
  components: {
    LazyImage,
    List,
    ListItem,
    Divider
  },
  props: {
    ...deliveryInfoProps()
  },
  setup(props) {
    const { printFile, codeFormatted } = useDeliveryInfo(props);
    return {
      printFile,
      codeFormatted,
      withdrawalOver,
      box,
      scanQrcode
    };
  }
};
</script>

<template>
  <div class="u-border-grey-4 u-p-md u-radius-sm u-mb-md">
    <h2 class="u-font-24 u-color-primary u-mb-sm">
      Comment retirer votre commande au retrait Delipop
    </h2>
    <Divider
      dotted
      size="sm"
      class="u-mb-md"
    />

    <List class="c-order-confirmation__delivery-list">
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="scanQrcode"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Scannez votre QR code Saisissez votre numéro de commande sur l'écran
          </p>
          <p class="u-font-15 u-font-secondary">
            {{ codeFormatted }}
          </p>
        </div>
      </ListItem>
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="box"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Renouvelez l'opération à la borne pour récupérer votre commande
          </p>
          <p class="u-font-15 u-font-secondary">
            Vous pouvez alors retirer votre commande.
          </p>
        </div>
      </ListItem>
      <ListItem class="c-order-confirmation__delivery-list-item">
        <LazyImage
          :src="withdrawalOver"
          size="lg"
          height="72"
          width="72"
          class="u-mr-sm u-mr-none@sm"
        />
        <div class="u-pl-sm@sm u-full-width">
          <p class="c-order-confirmation__delivery-list-item-title">
            Le retrait est terminé
          </p>
          <p class="u-font-15 u-font-secondary">
            Si votre commande a été récupérée, le casier se ferme.
          </p>
        </div>
      </ListItem>
    </List>
    <p class="u-font-14 u-color-grey-2 u-mb-xs u-mt-lg">
      Cora se réserve le droit de vous demander de présenter une pièce d’identité.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/order-confirmation.scss";
</style>
